import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/auth/guards/auth-guard.service';
import { AppLayoutComponent } from './core/layout/app-layout/app-layout.component';
import { Error404Component } from './shared/components/error-404/error-404.component';

const childrenRoutes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        m => m.DashboardModule
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'exchange',
    loadChildren: () =>
      import('./modules/exchange/exchange.module').then(m => m.ExchangeModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'inbox',
    loadChildren: () =>
      import('./modules/messages/messages.module').then(m => m.MessagesModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'buy-sell',
    loadChildren: () =>
      import('./modules/buy-sell/buy-sell.module').then(m => m.BuySellModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./modules/settings/settings.module').then(m => m.SettingsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'loans',
    loadChildren: () =>
      import('./modules/loans/loans.module').then(m => m.LoansModule),
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    component: Error404Component
  }
];

export const routes: Routes = [
  {
    path: 'sign',
    loadChildren: () =>
      import('./modules/sign/sign.module').then(m => m.SignModule)
  },
  {
    path: '',
    component: AppLayoutComponent,
    children: childrenRoutes
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      relativeLinkResolution: 'corrected',
      anchorScrolling: 'enabled',
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
